module.exports = __webpack_public_path__ + "static/img/zhuanxiang_bg_1.7a8a34b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhuanxiang_bg_1.png
// module id = cvll
// module chunks = 27